import React, { useState } from "react";
import api from "../services/api";
import forms from "./forms.module.css";
import Navbar from "../components/Navbar.jsx";

const FormPage = () => {
  const [form, setForm] = useState({
    valorEnergetico: "",
    carboidrato: "",
    proteina: "",
    gorduraTotal: "",
    // ... outros campos
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/data", form);
      alert("Formulário enviado com sucesso!");
    } catch (err) {
      alert("Erro ao enviar o formulário");
    }
  };

  return (
    <>
      <Navbar />
      <form onSubmit={handleSubmit}>
        <div className={forms.form}>
          <div class={forms.formulario}>
            <div className={forms.title}>
              <h1>Dados Nutricionais</h1>
            </div>
            <div className={forms.l}>
              <b>
                <p>Insira valor energético:</p>
              </b>
              <input
                type="text"
                placeholder="Valor Energético"
                value={form.valorEnergetico}
                onChange={(e) =>
                  setForm({ ...form, valorEnergetico: e.target.value })
                }
              />
            </div>
            <div className={forms.l}>
              <b>
                <p>Insira valor carboidrato:</p>
              </b>
              <input
                type="text"
                placeholder="Carboidrato"
                value={form.carboidrato}
                onChange={(e) =>
                  setForm({ ...form, carboidrato: e.target.value })
                }
              />
            </div>
            <div className={forms.l}>
              <b>
                <p>Insira valor proteina:</p>
              </b>
              <input
                type="text"
                placeholder="Proteína"
                value={form.proteina}
                onChange={(e) => setForm({ ...form, proteina: e.target.value })}
              />
            </div>
            <div className={forms.l}>
              <b>
                <p>Insira valor gorduras totais:</p>
              </b>
              <input
                type="text"
                placeholder="Gordura Total"
                value={form.gorduraTotal}
                onChange={(e) =>
                  setForm({ ...form, gorduraTotal: e.target.value })
                }
              />
            </div>
            <div className={forms.botao}>
              <button type="submit">
                <b>Enviar</b>
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default FormPage;
